import React, { useState } from 'react';
import ReactExport from 'react-data-export';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import FiterAPI from '../fiterAPI';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

function numberToState(value) {
  return (
    (value < 10 && {
      value: 'PD',
      style: { font: { color: { rgb: 'dc3545' } } }
    }) ||
    (value <= 15 && {
      value: 'Neutro',
      style: { font: { color: { rgb: 'dcc335' } } }
    }) || { value: 'Força', style: { font: { color: { rgb: '2dba2d' } } } }
  );
}

function ExportPulses(props) {
  const { avatar, courses, monthFilter, currentInstitution } = props;
  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState('export');
  async function getPulsesData() {
    setIsLoading(true);
    const { data } = await FiterAPI.getPulses({ limit: 30000, monthFilter });
    const date = new Date();
    setFileName(
      !monthFilter?.filterKey
        ? `export-${avatar.institutionName
        }-${date.getUTCDate()}-${date.getUTCMonth() +
        1}-${date.getUTCFullYear()}`
        : `export-${avatar.institutionName}-${monthFilter?.filterKey}`
    );

    const dataAnswer = [];
    _.map(data, (answer, index) => {
      dataAnswer[index] = [
        { value: answer.name },
        { value: answer.areaName },
        { value: answer.courseName },
        { value: answer.unitName },
        { value: answer.date },
        numberToState(answer.answers['question-0']),
        numberToState(answer.answers['question-1']),
        numberToState(answer.answers['question-2']),
        numberToState(answer.answers['question-3']),
        { value: answer.happiness },
        numberToState(answer.answers['question-4']),
        numberToState(answer.answers['question-5']),
        numberToState(answer.answers['question-6']),
        numberToState(answer.answers['question-7']),
        { value: answer.health },
        { value: answer.evasionLabel }
      ];

      if ((currentInstitution && currentInstitution.name === "Unime") || process.env.REACT_APP_FITER_ENV === 'development') {
        dataAnswer[index].push({ value: answer.comments })
        dataAnswer[index].push({ value: answer.firstDropdownValue })
        dataAnswer[index].push({ value: answer.secondDropdownValue })
        dataAnswer[index].push({ value: answer.action })
        dataAnswer[index].push({ value: answer.obs })
      }
    });

    const dataSet = [
      {
        columns: [
          { title: 'Nome', width: { wpx: 80 } },
          { title: 'Área', width: { wpx: 80 } },
          { title: 'Cargo', width: { wpx: 80 } },
          { title: 'Filial', width: { wpx: 80 } },
          { title: 'Data', width: { wpx: 80 } },
          { title: avatar.archetype[0], width: { wpx: 80 } },
          { title: avatar.archetype[1], width: { wpx: 80 } },
          { title: avatar.archetype[2], width: { wpx: 80 } },
          { title: avatar.archetype[3], width: { wpx: 80 } },
          { title: 'resultado', width: { wpx: 80 } },
          { title: avatar.archetype[4], width: { wpx: 80 } },
          { title: avatar.archetype[5], width: { wpx: 80 } },
          { title: avatar.archetype[6], width: { wpx: 80 } },
          { title: avatar.archetype[7], width: { wpx: 80 } },
          { title: 'Resultado', width: { wpx: 80 } },
          { title: 'Risco de Turnover', width: { wpx: 80 } },
          { title: 'Comentários do Colaborador', width: { wpx: 80 } }
        ],
        data: dataAnswer
      }
    ];
    if ((currentInstitution && currentInstitution.name === "Unime") || process.env.REACT_APP_FITER_ENV === 'development') {
      dataSet[0].columns.push({
        title: 'Conversou com o aluno?',
        width: { wpx: 160 },
        style: {
          fill: { patternType: 'solid', fgColor: { rgb: 'C7DDB5' } }
        }
      })
      dataSet[0].columns.push({
        title: 'O que o aluno reportou?',
        width: { wpx: 160 },
        style: {
          fill: { patternType: 'solid', fgColor: { rgb: 'C7DDB5' } }
        }
      })
      dataSet[0].columns.push({
        title: 'Ação',
        width: { wpx: 160 },
        style: {
          fill: { patternType: 'solid', fgColor: { rgb: 'C7DDB5' } }
        }
      })
      dataSet[0].columns.push({
        title: 'Observação',
        width: { wpx: 160 },
        style: {
          fill: { patternType: 'solid', fgColor: { rgb: 'C7DDB5' } }
        }
      })
    }
    setDataList(dataSet);
    setIsLoading(false);
  }

  async function showModal() {
    setShow(true);

    await getPulsesData();
  }
  return (
    <>
      <Button variant="secondary" onClick={() => showModal(true)}>
        <FontAwesomeIcon icon={faFileDownload} />
        <span>Exportar pulsos do mês</span>
      </Button>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton />
        <Modal.Body>
          {isLoading ? (
            <>
              <h4>Gerando download...</h4>
              <div className="spinner-border" />
            </>
          ) : (
            <ExcelFile filename={fileName}>
              <ExcelSheet
                dataSet={dataList}
                element={<FontAwesomeIcon icon={faFileDownload} />}
                name="Organization"
              />
            </ExcelFile>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ExportPulses;
